import type { RouteRecordRaw } from 'vue-router';

/**
 * Routes appended by make feature.
 * Add manual custom routes in featureRoutes.ts instead.
 */
export const generatedFeatureRoutes: RouteRecordRaw[] = [];
